import { formatCurrency, nricOrPassport, standardDate } from 'helpers/common.helper';

// Patient Information Section
export const dateRefClaim = (details, status, color) => {
  const dRCList = [
    { title: 'Date Attended', value: details.date },
    { title: 'Reference No.', value: details.id },
    { title: 'Claim Status',  value: status, slug: 'claim-status' }
  ]

  return dRCList.map((hash, index) => {
    const padding   = ['pr-1', 'px-1', 'pl-1'][index];
    const textColor = index === 2 ? ' text-' + color : '';

    return (
      <div className={ "col " + padding } key={ index }>
        <div className="date-ref-claim-box p-4 text-center h-100">
          <p className="text-lightgrey mb-0 font-size-3">{ hash.title }</p>
          <p className={ "mb-0" + textColor }><b>{ hash.value }</b></p>
          {(hash.slug === 'claim-status' && details.status === 'rejected') &&
            <p className="mb-0 font-size-4"><b>( { details.approval_notes } )</b></p>
          }
        </div>
      </div>
    )
  });
}

// Medical Bill Section
export const medicalBill = (details, category, balance, display_address) => {
  const patientInfo = [
    { title: 'Policy Owner',      value: details.personal_info.policy_owner },
    { title: 'NRIC/Passport No.', value: nricOrPassport(details.personal_info.nric) },
    { title: 'Membership No.',    value: details.personal_info.membership_no },
    { title: 'Effective Date',    value: standardDate(details.personal_info.effective_date) },
    { title: 'Company Name',      value: details.personal_info.company_name },
    { title: 'Employee\'s ID',    value: details.personal_info.corporate_employee_id },
    { title: 'Visit Limit',       value: 'MYR ' + formatCurrency(details.claim_limit) },
    { title: 'Entitlement',       value: details.entitlement_name },
    { title: 'Category',          value: category },
    { title: 'Doctor',            value: details.practice_location.doctor_name },
    { title: 'Practice Location', value: details.practice_location.name },
    { title: 'Address',           value: details.practice_location.address },
  ]

  if (balance) {
    patientInfo.splice(
      8, 0,
      { title: 'Balance', value: 'MYR ' + formatCurrency(balance) }
    );
  }

  const byChunks = patientInfo.reduce((memo, value, index) => {
    if (index % 2 === 0 && index !== 0) memo.push([])
    memo[memo.length - 1].push(value)
    return memo
  }, [[]]);

  const cells = byChunks.map((array, index) => {
    return (
      <div className="row" key={ index }>
        <div className="col">
          <p className="text-lightgrey mb-0 font-size-3">{ array[0]?.title }</p>
          <p><b>{ array[0]?.value || '-'  }</b></p>
        </div>

        <div className="col">
          <p className="text-lightgrey mb-0 font-size-3">{ array[1]?.title }</p>
          <p><b>{ array[1] ? (array[1]?.value || '-') : null }</b></p>
        </div>
      </div>
    )
  });

  const exclusionDoc = details.policy_link;

  return (
    <div>
      { cells }

      { exclusionDoc &&
        <a className="text-danger" href={ exclusionDoc } target="_blank" rel="noreferrer">View Exclusion List</a> }
    </div>
  );
}

// Disclaimer Section
export const disclaimer = () => {
  const disclaimerList = [
    'Please check for spelling and information errors BEFORE you submit this claim.',
    'The claim’s information CANNOT be edited/changed after you have submitted it.',
    'BookDoc is not responsible for any errors or misinformation from the claims submitted by our healthcare providers.',
    'Healthcare providers are not allowed to charge more than the patient’s entitled visit limits.'
  ];

  return disclaimerList.map((text, index) => {
    const withNoMargin = index + 1 < disclaimerList.length ? '' : ' mb-0';

    return (
      <div className="d-flex font-size-3" key={ index }>
        <p className={ "w-em-4 flex-shrink-0" + withNoMargin }>{ index + 1 }.</p>
        <p className={ withNoMargin }>{ text }</p>
      </div>
    )
  });
}